module.exports = __webpack_public_path__ + "static/fonts/CircularStd-Black.d8aa41e2.woff";